import { map } from 'rxjs/operators'
import { Injectable } from '@angular/core'
import { Retry } from '@services/decorators/retry.decorator'
import { HttpClient } from '@angular/common/http'
import { ManagementApiBaseService } from '@services/api/management-api-base.service'
import {
	SupplierEnrollmentNoticeTradingSearch,
	SupplierEnrollmentNoticeTrading,
	SupplierEnrollmentNoticeTradingRequest
} from '@models/supplier/notice/proposal/supplier-enrollment-notice-trading.model'

@Injectable({
	providedIn: 'root'
})
export class SupplierEnrollmentNoticeTradingService extends ManagementApiBaseService<SupplierEnrollmentNoticeTradingSearch> {
	private readonly source: string

	constructor(override http: HttpClient) {
		super(http)
		this.sortColumn = 'createdAt'
		this.source = 'supplier-enrollment-notice-trades'
		this.searchTerm = new SupplierEnrollmentNoticeTradingSearch()
	}

	save(request: SupplierEnrollmentNoticeTradingRequest) {
		return this.post<SupplierEnrollmentNoticeTradingRequest, SupplierEnrollmentNoticeTrading>(`${this.source}`, request).pipe(
			map(response => new SupplierEnrollmentNoticeTrading(response))
		)
	}

	latest(sessionId: string, enrollmentId: string) {
		return this.get<SupplierEnrollmentNoticeTrading>(`${this.source}/latest/${sessionId}/${enrollmentId}`).pipe(
			map(response => new SupplierEnrollmentNoticeTrading(response))
		)
	}

	@Retry(3)
	opened(id: string, proposals: Array<{ item: { id: string } }>, description?: string) {
		return this.patch<any>(`${this.source}/opened`, { id, proposals, description })
	}

	@Retry(3)
	closed(id: string, proposals: Array<{ item: { id: string } }>, description?: string) {
		return this.patch<any>(`${this.source}/closed`, { id, proposals, description })
	}
}
